import { Fragment, useState } from 'react';
import { track } from '../../../../tracking';
import { gridDotsIcon } from '../../../common/Icons';
import ModalDialog from '../../../common/ModalDialog';
import { IFrameBareDialog } from '../../../common/IFrameDialog';

const gridDotsIcons = gridDotsIcon('fill-white');

export const NewUpdateComponent: React.FC<{
    mainText: string;
    subText: string;
    lsKey: string;
    trackingEventName: string;
    element: string;
    url: string;
    iframeId: string;
}> = ({ mainText, subText, lsKey, trackingEventName, element, url, iframeId }) => {
    const [isStrip, setisStrip] = useState(localStorage.getItem(lsKey));
    const [showVideo, setShowVideo] = useState(false);

    const tellMeMore = () => {
        track(trackingEventName);
        setShowVideo(true);
    };

    const onClose = () => {
        localStorage.setItem(lsKey, 'false');
        setisStrip('false');
        track('CROSS', {
            element: element,
        });
    };

    if (isStrip === 'false') {
        return null;
    }

    return (
        <Fragment>
            <div className="mb-8 flex relative justify-between bg-darwin-green-bg-dark items-center py-14 pl-12 pr-24 w-full border rounded-8 border-darwin-green-primary">
                <div
                    onClick={onClose}
                    className="absolute py-4 px-4 bg-darwin-neutral-800 -top-10 -right-8 rounded-full"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 320 512"
                        className="w-12 h-12 fill-white cursor-pointer hover:fill-darwin-accent-investigations-ochre-200"
                    >
                        <path d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
                    </svg>
                </div>
                <div className="flex items-top">
                    <div className="mt-4 uppercase max-h-24 text-12 font-700 text-white px-11 py-3 bg-darwin-green-primary rounded-4">
                        New
                    </div>
                    <div className="ml-14 font-400 text-14 leading-tight">
                        <p className="pb-3 font-700 text-16">{mainText}</p>
                        <p>{subText}</p>
                    </div>
                </div>
                <button
                    onClick={tellMeMore}
                    className="flex justify-center items-center space-x-8 rounded-4 p-8 px-15 ml-41 text-white text-14 font-700 bg-darwin-accent-bright-blue-800 announcekit-widget"
                >
                    <span>{gridDotsIcons}</span>
                    <span className="text-center text-14 font-700 whitespace-nowrap">
                        Tell me more!
                    </span>
                </button>
            </div>
            {showVideo && (
                <ModalDialog>
                    <IFrameBareDialog
                        url={url}
                        id={iframeId}
                        closeMe={() => setShowVideo(false)}
                        style={{ width: '720px', height: '476px' }}
                    />
                </ModalDialog>
            )}
        </Fragment>
    );
};
